import { useState } from 'react';
import automobyApi from '../Api';
import { useUpdateEffect } from './useUpdateEffect';
import { useUpdateQueryParams, useReadQueryParams } from './useQueryParams';

export const useBooking = (defaultPageSize) => {
  const updateQueryParams = useUpdateQueryParams();
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    sender_country_id: 0,
    reciever_country_id: 0,
    sender_city_id: 0,
    reciever_city_id: 0,
    is_active: true,
    name: "", 
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      updateQueryParams(filter);
      const response = await automobyApi.post("/booking/list", filter)
      setItems(response.data.bookings);
      setTotal(response.data.total);
      return response.data.bookings
    } catch (error) { 
      console.error("თუ ერორია:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/booking/all", requestData)
      setItems(response.data.bookings);
      setTotal(response.data.total);
      return response.data.bookings
    } catch (error) {

      console.error("თუ ერორია:" + error);
    }
  }

  const add = async (newData) => {
    try {
        console.log("this will be added:", newData)
      const response = await automobyApi.post(`/booking/add`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (booking, count) => {
    try {
      const requestData = {
        booking: booking,
        count: count,
      };

      const response = await automobyApi.post("/booking/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/booking/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          Booking_id: id
        };
        const response = await automobyApi.post(`/booking/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const getBooking = (senderCityId, recieverCityId) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          sender_city_id: senderCityId,
          reciever_city_id: recieverCityId 
        };
        const response = await automobyApi.post(`/booking/get`, requestData);
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  } 
  
  const BookingService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
    getBooking: getBooking,
  };

  return { BookingService };
}